export default __webpack_public_path__ + "static/media/user-light.c8e5e126.svg";